<template>
  <div>
    <div class="col-md-12 col-xl-12">
      <div class="card card-statistics">
        <div class="card-header">
          <h4 class="card-title">{{ $t("overView") }}</h4>
          <div class="d-flex justify-content-center">
            <div class="d-flex xet-width">
              <feather-icon icon="CalendarIcon" size="16" />
              <flat-pickr
                v-model="rangePicker"
                :config="config"
                class="
                  form-control
                  flat-picker
                  bg-transparent
                  border-0
                  shadow-none
                "
              />
            </div>
          </div>
        </div>
        <div class="card-body statistics-body">
          <div class="row">
            <div class="col-sm-6 col-xl-3 mb-2">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-danger rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="ShoppingCartIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <h4
                    @click="
                      () => {
                        $store.commit('tabView/SET_TAB_QUOTATION', '1,2');

                        $router.push({ name: 'user-my-quotation' });
                      }
                    "
                    class="font-weight-bolder mb-0 revenue"
                  >
                    {{ totalApproving | abbreviateNumber }}
                  </h4>
                  <p class="card-text font-small-3 mb-0">
                    {{ $t("approving") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3 mb-2">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-warning rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="BoxIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <router-link
                    :to="{ name: 'user-my-quotation' }"
                    class="font-weight-bolder mb-0 h4"
                    >{{ totalApproved | abbreviateNumber }}</router-link
                  >
                  <p class="card-text font-small-3 mb-0">
                    {{ $t("approved") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-primary rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="AwardIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <h4
                    @click="
                      () => {
                        $store.commit('tabView/SET_TAB_BOOKING', '61,62,63');

                        $router.push({ name: 'user-my-booking' });
                      }
                    "
                    class="font-weight-bolder mb-0 revenue"
                  >
                    {{ totalAcknowled | abbreviateNumber }}
                  </h4>
                  <p class="card-text font-small-3 mb-0">
                    {{ $t("bookingAcknowled") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
              <div class="media">
                <div class="media-aside mr-2 align-self-start">
                  <span
                    class="b-avatar badge-light-info rounded-circle"
                    style="width: 48px; height: 48px"
                    ><span class="b-avatar-custom">
                      <feather-icon
                        icon="TruckIcon"
                        width="24px"
                        height="24px"
                        class="rounded-full"
                      ></feather-icon> </span
                    ><!----></span
                  >
                </div>
                <div class="media-body my-auto">
                  <h4
                    @click="
                      () => {
                        $store.commit('tabView/SET_TAB_BOOKING', '8');

                        $router.push({ name: 'user-my-booking' });
                      }
                    "
                    class="font-weight-bolder mb-0 revenue"
                  >
                    {{ totalTransport | abbreviateNumber }}
                  </h4>
                  <p class="card-text font-small-3 mb-0">
                    {{ $t("beingTransport") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-xl-12">
      <div class="row">
        <div class="col-md-6 col-xl-6">
          <div class="card card-statistics">
            <div class="card-body statistics-body">
              <div class="row justify-content-center">
                <div class="col-sm-12 col-xl-12 my-2">
                  <div class="media">
                    <div class="media-body my-auto">
                      <h2
                        class="font-weight-bolder mb-0"
                        v-b-tooltip.hover
                        :title="
                          $i18n.locale == 'en'
                            ? $Utils.formatMooney(
                                totalPricing / exchangeRate,
                                'en-US'
                              ) + ' USD'
                            : $Utils.formatMooney(totalPricing, 'vi-VI') +
                              ' VND'
                        "
                      >
                        {{
                          ($i18n.locale == "en"
                            ? (totalPricing / exchangeRate).toFixed(0)
                            : totalPricing) | abbreviateNumber
                        }}
                        {{ $i18n.locale == "en" ? "USD" : "VND" }}
                      </h2>
                      <h6 class="card-text font-small-3 mb-0">
                        {{ $t("Cost") }}
                      </h6>
                    </div>
                    <div class="media-aside mr-2 align-self-start">
                      <span
                        class="b-avatar badge-light-info rounded-circle"
                        style="width: 96px; height: 96px"
                        ><span class="b-avatar-custom">
                          <feather-icon
                            icon="TagIcon"
                            width="48px"
                            height="48px"
                            class="rounded-full"
                          ></feather-icon> </span
                        ><!----></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-xl-6">
          <div class="card card-statistics">
            <div class="card-body statistics-body">
              <div class="row justify-content-center">
                <div class="col-sm-12 col-xl-12 my-2">
                  <div class="media">
                    <div class="media-body my-auto">
                      <h2
                        class="font-weight-bolder mb-0"
                        v-b-tooltip.hover
                        :title="
                          $i18n.locale == 'en'
                            ? $Utils.formatMooney(
                                totalDept / exchangeRate,
                                'en-US'
                              ) + ' USD'
                            : $Utils.formatMooney(totalDept, 'vi-VI') + ' VND'
                        "
                      >
                        {{
                          ($i18n.locale == "en"
                            ? (totalDept / exchangeRate).toFixed(0)
                            : totalDept) | abbreviateNumber
                        }}
                        {{ $i18n.locale == "en" ? "USD" : "VND" }}
                      </h2>
                      <h6 class="card-text font-small-3 mb-0">Dept</h6>
                    </div>
                    <div class="media-aside mr-2 align-self-start">
                      <span
                        class="b-avatar badge-light-warning rounded-circle"
                        style="width: 96px; height: 96px"
                        ><span class="b-avatar-custom">
                          <feather-icon
                            icon="XIcon"
                            width="48px"
                            height="48px"
                            class="rounded-full"
                          ></feather-icon> </span
                        ><!----></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <b-row>
        <!-- DONUT CHART -->
        <div
          class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
          v-if="donutChartQuotationServ !== null"
        >
          <b-card>
            <div class="justify-content-between">
              <!-- title and subtitle -->
              <div class="title-subtitle">
                <b-card-title class="m-0">{{ $t("quotation") }} </b-card-title>
              </div>
              <!--/ title and subtitle -->

              <!-- datepicker -->
              <div class="d-flex justify-content-center">
                <div class="d-flex xet-width">
                  <feather-icon icon="CalendarIcon" size="16" />
                  <flat-pickr
                    v-model="rangePicker"
                    :config="config"
                    class="
                      form-control
                      flat-picker
                      bg-transparent
                      border-0
                      shadow-none
                    "
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>

              <!-- datepicker -->
            </div>

            <vue-apex-charts
              type="donut"
              height="350"
              :options="donutChartQuotationServ.chartOptions"
              :series="donutChartQuotationServ.series"
            ></vue-apex-charts>
            <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
          </b-card>
        </div>
        <div
          class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
          v-if="donutChartBookingServ !== null"
        >
          <b-card>
            <div class="justify-content-between">
              <!-- title and subtitle -->
              <div class="title-subtitle">
                <b-card-title class="m-0">{{ $t("booking") }}</b-card-title>
              </div>
              <!--/ title and subtitle -->

              <!-- datepicker -->
              <div class="d-flex justify-content-center">
                <div class="d-flex xet-width">
                  <feather-icon icon="CalendarIcon" size="16" />
                  <flat-pickr
                    v-model="rangePicker"
                    :config="config"
                    class="
                      form-control
                      flat-picker
                      bg-transparent
                      border-0
                      shadow-none
                    "
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>

              <!-- datepicker -->
            </div>
            <vue-apex-charts
              type="donut"
              height="350"
              :options="donutChartBookingServ.chartOptions || []"
              :series="donutChartBookingServ.series"
            ></vue-apex-charts>
            <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
          </b-card>
        </div>
        <div
          class="col-sm-12 col-md-4 vx-col md:w-1/2 mb-base"
          v-if="donutChartRevenueServ !== null"
        >
          <b-card>
            <div class="justify-content-between">
              <!-- title and subtitle -->
              <div class="title-subtitle">
                <b-card-title class="m-0">{{ $t("Total Cost") }}</b-card-title>
              </div>
              <!--/ title and subtitle -->

              <!-- datepicker -->
              <div class="d-flex justify-content-center">
                <div class="d-flex xet-width">
                  <feather-icon icon="CalendarIcon" size="16" />
                  <flat-pickr
                    v-model="rangePicker"
                    :config="config"
                    class="
                      form-control
                      flat-picker
                      bg-transparent
                      border-0
                      shadow-none
                    "
                  />
                </div>
              </div>

              <!-- datepicker -->
            </div>
            <vue-apex-charts
              type="donut"
              height="350"
              :options="donutChartRevenueServ.chartOptions || []"
              :series="donutChartRevenueServ.series"
            ></vue-apex-charts>
            <!-- <template slot="codeContainer">
          {{ apexChatData.donutChartCode }}
        </template> -->
          </b-card>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import { Utils } from "@/@core/utils/utilsCustom";
import moment from "moment";

import { getUserData } from "@/auth/utils";
import {
  getCustomerTotalOverView,
  getCustomerTotalQuotationByServ,
  getCustomerTotalBookingByServ,
  getCustomerTotalRevenueByServ,
} from "@/api";
export default {
  components: {
    BRow,
    BCol,
    VueApexCharts,
  },
  data() {
    return {
      config: {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
      },
      rangePicker: ["2019-05-01", "2019-05-10"],

      donutChart: {
        series: [44, 55, 41, 17, 14, 4],
        chartOptions: {
          dataLabels: {
            enabled: false,
          },
          labels: [
            "Air",
            "FCL",
            "LCL",
            "Custom",
            "Container trucking",
            "Van trucking",
          ],
          colors: [
            "#7367F0",
            "#28C76F",
            "#EA5455",
            "#FF9F43",
            "#1E991E",
            "#EA5485",
          ],

          legend: {
            show: true,
            position: "bottom",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: "1.5rem",
                        },
                        value: {
                          fontSize: "1rem",
                        },
                        total: {
                          fontSize: "1.5rem",
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },

      totalApproving: 0,
      totalApproved: 0,
      totalAcknowled: 0,

      totalTransport: 0,
      totalDept: 0,
      totalPricing: 0,

      donutChartQuotationServ: null,
      donutChartBookingServ: null,
      donutChartRevenueServ: null,
    };
  },
  watch: {
    rangePicker: function (newVal, oldVal) {
      if (newVal != oldVal) {
        const newDate = typeof newVal == "string" ? newVal.split(" ") : "";
        if (newDate) {
          const arr2 = newDate[2] ? newDate[2] : newDate[0];

          this.init(moment(String(newDate[0])).format("DD/MM/YYYY"), arr2);
        }
      }
    },
  },
  async created() {
    this.$store.dispatch("masterData/fetchRate");

    // data
    const { firstDay, lastDay } = Utils.getFirstAndLastDateOfCurrentMonth();

    this.rangePicker = [
      moment(String(firstDay)).format("YYYY/MM/DD"),
      moment(String(lastDay)).format("YYYY/MM/DD"),
    ];
    this.init(
      moment(String(firstDay)).format("DD/MM/YYYY"),
      moment(String(lastDay)).format("YYYY/MM/DD")
    );
  },
  mounted() {},
  computed: {
    exchangeRate: function () {
      return this.$store.getters["masterData/exchangeRate"];
    },
  },
  methods: {
    track () {
      this.$gtag.pageview('Dashboard KH')
    },
    formatDate(val) {
      return moment(String(val)).format("DD/MM/YYYY");
    },
    async init(firstDay, lastDay) {
      getCustomerTotalOverView({
        approvingStatus: Utils.CONSTANTS.STATUS_WR1.APPROVING,
        approvedStatus: Utils.CONSTANTS.STATUS_WR1.APPROVED,
        acknowledStatus: Utils.CONSTANTS.STATUS_WR1.ACKNOWLED,
        pricingStatus: Utils.CONSTANTS.STATUS_WR1.PRICING,
        deptStatus: Utils.CONSTANTS.STATUS_WR1.DEPT,
        transportStatus: Utils.CONSTANTS.STATUS_WR1.TRANSPORT,
        startDate: firstDay,
        endDate: lastDay ? this.formatDate(lastDay) : firstDay,
      }).then((rs) => {
        if (rs) {
          this.totalApproving = rs.approving;
          this.totalApproved = rs.approved;
          this.totalAcknowled = rs.acknowled;
          this.totalDept = rs.dept;
          this.totalTransport = rs.transport;
          this.totalPricing = rs.pricing;
        }
      });

      //service Quotation
      const resultTotalQuotationByServ = await getCustomerTotalQuotationByServ({
        quotationStatus: Utils.CONSTANTS.STATUS_WR1.QUOTATION,
        startDate: firstDay,
        endDate: lastDay ? this.formatDate(lastDay) : firstDay,
      });

      const quotationServ = await Utils.formatCharts(
        resultTotalQuotationByServ
      );
      this.donutChartQuotationServ = Utils.donutChart(
        quotationServ.seriesArr,
        quotationServ.categoriesArr
      );

      //service Booking
      const resultWR1TotalBookingByServ = await getCustomerTotalBookingByServ({
        bookingStatus: Utils.CONSTANTS.STATUS_WR1.BOOKING,
        startDate: firstDay,
        endDate: lastDay ? this.formatDate(lastDay) : firstDay,
      });

      const bookingServ = await Utils.formatCharts(resultWR1TotalBookingByServ);
      this.donutChartBookingServ = Utils.donutChart(
        bookingServ.seriesArr,
        bookingServ.categoriesArr
      );

      //service Revenue
      const resultWR1TotalRevenueByServ = await getCustomerTotalRevenueByServ({
        revenueStatus: Utils.CONSTANTS.STATUS_WR1.REVENUE,
        startDate: firstDay,
        endDate: lastDay ? this.formatDate(lastDay) : firstDay,
      });

      const revenueServ = await Utils.formatCharts(resultWR1TotalRevenueByServ);
      this.donutChartRevenueServ = Utils.donutChart(
        revenueServ.seriesArr,
        revenueServ.categoriesArr
      );
    },
  },
  filters: {
    abbreviateNumber: function (n) {
      if (n < 1e3) return n;
      if (n >= 1e3 && n < 1e6)
        return n.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
      if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
      if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
</style>
<style >
input.form-control.flat-picker.bg-transparent.border-0.shadow-none.form-control.input {
  margin-top: -0.8rem;
}
.title-subtitle {
  text-align: center;
}

.revenue {
  cursor: pointer;
}
.revenue:hover {
  color: #257f79;
}
</style>